import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { LeadService } from 'src/app/private/services/lead.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { TrackingService } from 'src/app/private/services/tracking.service';
import { LeadActivityService } from 'src/app/private/services/lead-activity.service';

@Component({
  selector: 'app-add-note',
  templateUrl: './add-note.component.html',
  styleUrls: ['./add-note.component.scss']
})
export class AddNoteComponent {
  @Output() close = new EventEmitter<void>();
  @Output() reload = new EventEmitter<void>();
  btnLoading = false;
  @Input() editFieldValues: any;
  constructor(private toaster: ToastrService,
    private api: LeadService,
    private localstorage: LocalStorageService,
    private tracker: TrackingService,
    private leadActivity: LeadActivityService
  ) { }

  @Input() editNoteData: any;
  @Input() type = 'Add';



  description = '';
  closeModal() {
    this.close.emit();
  }

  ngOnInit() {
    console.log("editFieldValues", this.editFieldValues);
    if (this.type === 'Update') {
      this.description = this.editNoteData.note_description;
    }
  }


  submitCreateNote() {

    if (!this.description) {
      this.toaster.error('Please enter a note');
      return;
    }

    this.btnLoading = true;

    const payload:any = {
      "note_description": this.description,
      "lead_id": this.editFieldValues.lead_id,
      "client_id": this.localstorage.getClientId(),
      "user_id": this.localstorage.getUserId(),
      "center_id": this.localstorage.getCenterId(),
    }
     const noteAction = this.type === 'Update' ? 'Update' : 'Create';
  const noteDesc = `Note ${noteAction.toLowerCase()}d for Lead ID: ${this.editFieldValues.lead_id}, Description: ${this.description}`;


    if (this.type === 'Update') {

      payload['note_id'] = this.editNoteData.note_id;
      this.api.updateNote(payload).subscribe({
        next: (res) => {
          this.toaster.success("Note updated successfully");
          this.tracker.track("Update", "Lead Note", noteDesc); // ✅ tracking
          this.btnLoading = false;
          this.reload.emit();
          this.description = '';
          this.closeModal();
        },
        error: (err) => {
          this.toaster.error(err.error.message || 'Something went wrong');
          this.btnLoading = false;
        }
      });

    } else {
      this.api.addNote(payload).subscribe({
        next: (res) => {
          this.toaster.success("Note created successfully");
           this.tracker.track("Create", "Lead Note", noteDesc); // ✅ tracking
          const noteId = res?.note_id ?? res?.id;
          const finish = () => {
            this.btnLoading = false;
            this.reload.emit();
            this.description = '';
            this.closeModal();
          };
          if (noteId) {
            this.leadActivity
              .recordNoteCreated(this.editFieldValues.lead_id, noteId, this.description)
              .subscribe({ next: finish, error: finish });
          } else {
            finish();
          }
        },
        error: (err) => {
          this.toaster.error(err.error.message || 'Something went wrong');
          this.btnLoading = false;
        }
      });
    }
  }


}
